import * as React from "react";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { ActionButton } from "@fluentui/react/lib/components/Button/ActionButton/ActionButton";
import DecommissionDialog from "../DecommissionDialog/DecommissionDialog";

class DataPrivacyLastUpdated extends React.Component {

    /* eslint-disable */
    constructor(props) {
        super(props);
    }
    /* eslint-enable */

    state = {
        lastUpdatedByAdminDt: "",
        lastUpdatedByAdminDtExists: false,
        lastAcceptedByUserDt: "",
        lastAcceptedByUserDtExists: false,
        showAcceptDialog: false
    }

    componentDidMount() {
        console.log("start componentDidMount");

        const tmpLastUpdatedByAdminDt: string = process.env.APP_DATA_PRIVACY_STATEMENT_LAST_UPDATED_ISO8601 ?? "";
        const tmpLastUpdatedByAdminDtExists: boolean = (tmpLastUpdatedByAdminDt.length > 0);

        console.log("tmpLastUpdatedByAdminDt='" + tmpLastUpdatedByAdminDt + "'");
        console.log("tmpLastUpdatedByAdminDtExists='" + tmpLastUpdatedByAdminDtExists + "'");

        if (tmpLastUpdatedByAdminDtExists === false) {
            // do nothing - no date time provided
            console.log("no date time provided by admin when data-privavy-statement has been updated > do nothing");
        } else if (Date.now() - Date.parse(tmpLastUpdatedByAdminDt) < 0) {
            // check if date time provided by admin is in future
            console.log("WARNING: date time provided by admin is in future > do nothing");
        } else {
            // date time provided > check if user accepted it
            const tmpLastAcceptedByUserDt: string = LocalCacheHelper.GetLocalStorageItemDataPrivStateLastUpdated();
            const tmpLastAcceptedByUserDtExists: boolean = (tmpLastAcceptedByUserDt.length > 0);

            console.log("tmpLastAcceptedByUserDt='" + tmpLastAcceptedByUserDt + "'");
            console.log("tmpLastAcceptedByUserDtExists='" + tmpLastAcceptedByUserDtExists + "'");

            let tmpshowAcceptDialog: boolean = false;

            if (tmpLastAcceptedByUserDtExists === false) {
                // user never accepted data-privacy-statement > show dialog
                console.log("user never accepted data-privacy-statement > show dialog");
                tmpshowAcceptDialog = true;
            } else if (Date.parse(tmpLastAcceptedByUserDt) - Date.parse(tmpLastUpdatedByAdminDt) < 0) {
                // user accated dps but there exists a newer one which needs to be accepted again > show dialog
                console.log("user accepted data-privacy-statement but there exists a newer one which needs to be accepted again > show dialog");
                tmpshowAcceptDialog = true;
            } else {
                // user accepted dps and there exists no newer one > do NOT show dialog
                console.log("user accepted data-privacy-statement and there exists no newer one > do NOT show dialog");
            }

            console.log("tmpshowAcceptDialog='" + tmpshowAcceptDialog + "'");

            this.setState({
                lastUpdatedByAdminDt: (tmpLastUpdatedByAdminDtExists) ? tmpLastUpdatedByAdminDt : "nicht angegeben",
                lastUpdatedByAdminDtExists: tmpLastUpdatedByAdminDtExists,
                lastAcceptedByUserDt: tmpLastAcceptedByUserDtExists ? tmpLastAcceptedByUserDt : "nicht angegeben",
                lastAcceptedByUserDtExists: tmpLastAcceptedByUserDtExists,
                showAcceptDialog: tmpshowAcceptDialog
            });
        }
    }

    componentWillUnmount() {
        console.log("start componentWillUnmount");
    }

    private onClickAccept = (): void => {
        console.log("onClickAccept");

        const dt: string = new Date().toISOString();
        LocalCacheHelper.SetLocalStorageItemDataPrivStateLastUpdated(dt);

        this.setState({
            lastAcceptedByUserDt: dt,
            lastAcceptedByUserDtExists: true,
            showAcceptDialog: false
        });
    };

    render() {
        // quick and dirty div-structure
        // maybe a blocking-dialog would be a better solution? > see: https://developer.microsoft.com/de-de/fluentui#/controls/web/dialog
        return (
            <div className={(this.state.showAcceptDialog === true) ? "doshowAcceptDialog" : "doNotShowAcceptDialog"}>
                { /* <p className="doshowAcceptDialogTitle">Datenschutzhinweise vom {new Date(this.state.lastUpdatedByAdminDt).toLocaleDateString()}, </p> */}
                <p className="doshowAcceptDialogText"> Bitte bestätigen Sie, dass Sie die aktuellen <a href="/privacy.html" className="doshowAcceptDialogLink" target="_blank">Datenschutzhinweise</a> akzeptieren.</p>
                <ActionButton
                    onClick={this.onClickAccept}
                    allowDisabledFocus
                    className="doshowAcceptDialogButton"
                >
                    Akzeptieren
                </ActionButton>
            </div >
        );
    }

}

export default DataPrivacyLastUpdated;
